// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../utils/firebase';
import {
  SCHEDULER_DASHBOARD_COLLECTION,
} from '../utils/firestoreCollections';

const SUMMARY_DOC_ID = 'summary';

/**
 * Live stats from schedulerDashboard/summary (runsTotal, runsSucceeded, runsFailed).
 */
function useSchedulerDashboardSummary() {
  const [stats, setStats] = useState({
    runsTotal: null,
    runsSucceeded: null,
    runsFailed: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const ref = doc(db, SCHEDULER_DASHBOARD_COLLECTION, SUMMARY_DOC_ID);
    const unsub = onSnapshot(
      ref,
      (snapshot) => {
        if (!snapshot.exists()) {
          setStats({
            runsTotal: 0,
            runsSucceeded: 0,
            runsFailed: 0,
          });
        } else {
          const summaryData = snapshot.data();
          setStats({
            runsTotal: summaryData.runsTotal ?? 0,
            runsSucceeded: summaryData.runsSucceeded ?? 0,
            runsFailed: summaryData.runsFailed ?? 0,
          });
        }
        setLoading(false);
        setError(null);
      },
      (subscriptionError) => {
        console.error('useSchedulerDashboardSummary', subscriptionError);
        setError(subscriptionError);
        setLoading(false);
      },
    );
    return () => unsub();
  }, []);

  return { stats, loading, error };
}

export default useSchedulerDashboardSummary;
